import React, { useState } from "react"
import styled from "styled-components"
import { Collapse, List, ListItem, ListItemText } from "@material-ui/core"
import { ExpandLess, ExpandMore } from "@material-ui/icons"
import Device from "./device"

const Wrapper = styled.div`
  && {
    & > nav:last-child {
      padding-bottom: 0;
    }
  }
`

const StyledListItemText = styled(ListItemText)`
  && {
    & > span {
      font-size: 14px;
      line-height: 24px;
      font-weight: 800;
      color: #ffffff;
    }
  }
`

const StyledList = styled(List)`
  && {
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      height: 1px;
      width: 90%; /* or 100px */
      border-bottom: 1px solid rgba(51, 51, 51, 0.17);
    }
  }
`

const TitleWrapper = styled.div`
  && {
    background-color: #000000;
  }
`

const DeviceSection = ({ title, devices }) => {
  const [expand, setExpand] = useState(true)

  const handleExpand = () => {
    setExpand(!expand)
  }

  return (
    <>
      {!!devices.length && (
        <Wrapper>
          <StyledList component="nav" aria-labelledby="nested-list-subheader">
            <TitleWrapper>
              <ListItem button onClick={handleExpand}>
                <StyledListItemText>{title}</StyledListItemText>
                {expand ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </TitleWrapper>
            <Collapse in={expand} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {!!devices.length &&
                  devices.map((device, index) => (
                    <Device key={index} device={device} />
                  ))}
              </List>
            </Collapse>
          </StyledList>
        </Wrapper>
      )}
    </>
  )
}

export default DeviceSection
